const PORTAL_TOKEN_STORAGE_KEY = "lh_portal_token";

let _portalToken: string | null = null;

function readStoredPortalToken(): string | null {
  if (typeof window === "undefined") return null;

  try {
    return window.sessionStorage.getItem(PORTAL_TOKEN_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function readPortalToken(): string | null {
  if (_portalToken) return _portalToken;

  _portalToken = readStoredPortalToken();
  return _portalToken;
}

export function writePortalToken(token: string | null | undefined): void {
  _portalToken = token ?? null;

  if (typeof window === "undefined") return;

  try {
    if (_portalToken) {
      window.sessionStorage.setItem(PORTAL_TOKEN_STORAGE_KEY, _portalToken);
    } else {
      window.sessionStorage.removeItem(PORTAL_TOKEN_STORAGE_KEY);
    }
  } catch {
    // Safari private mode / locked-down browsers can reject storage writes.
    // Keep the in-memory copy so the current SPA session still works.
  }
}

export function clearPortalToken(): void {
  _portalToken = null;

  if (typeof window === "undefined") return;

  try {
    window.sessionStorage.removeItem(PORTAL_TOKEN_STORAGE_KEY);
  } catch {
    // Nothing else to do; the in-memory token is already cleared.
  }
}
